module.exports = __webpack_public_path__ + "static/media/shankarpur.b61328bc.jpg";